import * as PoolIndexActions from '../actions/poolIndex'

const initialState = {
  pools: [],
  totalItems: 0,
  itemsPerPage: 25,
  isLoading: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case PoolIndexActions.LOADPOOLS_REQUESTED:
      return {
        ...state,
        page: action.page,
        isLoading: true
      }

    case PoolIndexActions.LOADPOOLS:
      return {
        ...state,
        pools: action.data.data,
        totalItems: action.data.totalItems,
        isLoading: false
      }

    case PoolIndexActions.LOADPOOLS_ERROR:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }

    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/poolIndex.js